module.exports = __webpack_public_path__ + "static/media/java.891840bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/java.png
// module id = 614
// module chunks = 146